import React, { Component } from "react";
import { InputNumber, ConfigProvider } from "antd";
import { connect } from "react-redux";
import mask from "./phoneMask";
import quitmask from "./qPhoneMask";
import cuentaMask from './cuentaMask'
import quitCuentaMask from './qcuentaMask'
import { UpOutlined } from "@ant-design/icons";

class InputNumberItem extends Component {
  focused = false // instancia, no state: actualizacion sincronica
  render() {
      let propsNuevas = {}
      const decimales = this.props.decimalesEmpresa
      if(this.props.celular){
        propsNuevas.formatter = (value) => mask(value)
        propsNuevas.parser = (value) => quitmask(value)
      }else if(this.props.dinero){
        propsNuevas.formatter = (value) => {
          if (value === '' || value === null || value === undefined) return ''
          let str
          // Solo padear ceros cuando NO esta enfocado
          if (decimales && !this.focused) {
            const num = Number(value)
            if (isNaN(num)) return ''
            str = num.toFixed(decimales)
          } else {
            str = value.toString()
          }
          let arrayString = str.split('.')
          let primero = arrayString[0].replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
          let segundo = arrayString[1]
          if(segundo){
            return `$ ${primero}.${segundo}`
          }else{
            return `$ ${primero}`
          }
        };
        propsNuevas.parser = (value) => value.replace(/\$\s?|(,*)/g, '')
        if (decimales) {
          propsNuevas.precision = decimales
          propsNuevas.onFocus = (e) => {
            this.focused = true
            this.forceUpdate()
            if (this.props.onFocus) this.props.onFocus(e)
          }
          propsNuevas.onBlur = (e) => {
            this.focused = false
            // rAF asegura que el re-render ocurra DESPUES de que antd procese su blur interno
            requestAnimationFrame(() => this.forceUpdate())
            if (this.props.onBlur) this.props.onBlur(e)
          }
        }
      }else if(this.props.dineroDisabled){
        propsNuevas.formatter = (value) => {
          let arrayString = Number(value).toFixed(decimales ? decimales : 2).toString().split('.')
          let primero = arrayString[0].replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
          let segundo = arrayString[1]
          if(segundo){
            return `$ ${primero}.${segundo}`
          }else{
            return `$ ${primero}`
          }
        };
        propsNuevas.parser = (value) => value.replace(/\$\s?|(,*)/g, '')
      }else if(this.props.numeroCalle){
        propsNuevas.formatter = (value) => `# ${value}`
        propsNuevas.parser = (value) => value.replace('#', '')
      }else if(this.props.masMenos){
        propsNuevas.formatter = (value) => `± ${value}`
        propsNuevas.parser = (value) => value.replace('±', '')
      }else if(this.props.porcentaje){
        propsNuevas.formatter = (value) => `${value}%`
        propsNuevas.parser = (value) => value.replace('%', '')
      }else if(this.props.cuentaContable){
        propsNuevas.formatter = (value) => cuentaMask(value)
        propsNuevas.parser = (value) => quitCuentaMask(value)
      }
      let transformedProperties = {};
      for (var key in this.props) {
        if (
          !(
            key.toString() === "celular" ||
            key.toString() === "dinero" ||
            key.toString() === "dineroDisabled" ||
            key.toString() === "cuentaContable" ||
            key.toString() === "numeroCalle" ||
            key.toString() === "masMenos" ||
            key.toString() === "sinWidth" ||
            key.toString() === "porcentaje" ||
            key.toString() === "decimalesEmpresa"
          )
        ) {
          transformedProperties = {
            ...transformedProperties,
            [key]: this.props[key],
          };
        }
      }
      /*
      let style = {
        width: this.props.sinWidth ? '50%' : "100%" ,
        color: this.props.disabled ? 'black' : null,
        //'#F5F5F5'
        backgroundColor: this.props.disabled ? 'white' : null,
        borderBottom: this.props.sinBorde ? null : '1px solid #DADADA',
        borderRadius: 0,
        ...this.props.style
      }*/

        const style = {
          width: this.props.sinWidth ? '50%' : '100%',
          color: this.props.disabled ? '#757575' : undefined,
          backgroundColor: this.props.disabled ? '#FFFFFF' : undefined, // Fondo ligeramente gris
          borderBottom: this.props.sinBorde ? 'none' : '1px solid #E0FFFFFF',
          borderRadius: '4px', // Pequeño redondeo para bordes
          transition: 'border-color 0.3s ease', // Transición suave para el borde
          boxShadow: this.props.sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)', // Sombra suave
          ...this.props.style
        };
        
        
    return (
      <ConfigProvider direction={'rtl'}>
      <InputNumber
        bordered={false}
        style={style}
        {...propsNuevas}
        {...transformedProperties}
        placeholder={this.props.placeholder}
        controls={{upIcon: <UpOutlined style={{ color: "red" }} />}}
      />
      </ConfigProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  decimalesEmpresa: state.empresa.decimalesEmpresa,
});

export default connect(mapStateToProps)(InputNumberItem);
